import React from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const Consultations: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Consultations</h1>
      <p className="section-description">
        Manage consultation requests with comprehensive client information, business details, and consultation tracking features.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Consultation Management</h3>
              <p className="feature-description">
                Handle consultations with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit consultation requests</li>
                <li>Track consultation status</li>
                <li>Manage client information</li>
                <li>Delete individual consultations</li>
                <li>Bulk delete multiple consultations</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Client Information</h3>
              <p className="feature-description">
                Manage comprehensive client details:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>First and last name</li>
                <li>Email address</li>
                <li>Business type</li>
                <li>Consultation topic</li>
                <li>Additional information</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Consultation List</h3>
              <p className="feature-description">
                View and manage consultations in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>First name (searchable, sortable)</li>
                <li>Last name (searchable, sortable)</li>
                <li>Email (searchable, sortable)</li>
                <li>Business type (searchable, sortable)</li>
                <li>Consultation topic (searchable, sortable)</li>
                <li>Status (searchable, sortable)</li>
                <li>Creation date (sortable)</li>
                <li>Last update date (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Status Management</h3>
              <p className="feature-description">
                Track and manage consultation status:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Pending status</li>
                <li>In Progress status</li>
                <li>Completed status</li>
                <li>Cancelled status</li>
                <li>Status filtering</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Keep client information up to date</li>
            <li>Regularly update consultation status</li>
            <li>Review consultation topics for trends</li>
            <li>Maintain clear communication with clients</li>
            <li>Document additional information thoroughly</li>
            <li>Follow up on completed consultations</li>
            <li>Archive inactive consultations</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Consultations; 